import { Component, OnInit } from "@angular/core";
import {
  DatoPaginadoModel,
  Paging,
} from "src/app/shared/models/dato-paginado.model";
import {
  FormGroup,
  FormBuilder,
  FormArray,
  FormControl,
  ValidatorFn,
} from "@angular/forms";
import { AuthService } from "src/app/shared/services/auth.service";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";
import { HttpEventType } from "@angular/common/http";
import * as FileSaver from "file-saver";
import { ReporteSancionesPersonasService } from "./reporte-sanciones-personas.service";
import { IEstadoSancion } from "../../gestion/sanciones-personas/sanciones-persona.interface";
import { SancionesPersonasService } from '../../gestion/sanciones-personas/sanciones-personas.service';
import { DepartamentoEntry } from "src/app/shared/entrys/departamento.entry";
import { MunicipioEntry } from "src/app/shared/entrys/municipio.entry";
import { BasicasLoVService } from "src/app/shared/services/basicas-lov.service";
import { Validators } from '@angular/forms';

@Component({
  selector: "app-reporte-sanciones-personas",
  templateUrl: "./reporte-sanciones-personas.component.html",
  styleUrls: ["./reporte-sanciones-personas.component.scss"]
})

export class ReporteSancionesPersonasComponent implements OnInit {
  dataTabla: DatoPaginadoModel;
  estados_sanciones: Array<IEstadoSancion>;
  departamentos: Array<DepartamentoEntry>;
  municipios: Array<MunicipioEntry>;
  headerTabla: Array<string>;
  paginaActual: number;
  columnas: Array<any> = [];
  columnasEnvio: any;
  filtro: FormGroup;
  formCheck: FormGroup;
  public isCollapsed = true;
  isExportar = true;
  fecha_inicio: any;
  exportarForm: FormGroup;
  exportarList = [
    { id: "Nombre", name: "Nombres y Apellidos" },
    { id: "Numero_Identificacion", name: "Número de Identificación" },
    { id: "Desc_Dpto", name: "Departamento" },
    { id: "Desc_Municipio", name: "Municipio" },
    { id: "Direccion", name: "Dirección" },
    { id: "Numero_Telefonico", name: "Número Celular" },
    { id: "Correo", name: "Correo Electrónico" },
    { id: "Correo_Fiscal", name: "Correo Electrónico Fiscal" },
    { id: "Numero_Resolucion", name: "Número Resolución" },
    { id: "Fecha_Exp_Acto_Admin", name: "Fecha Expedición de Acto Administrativo" },
    { id: "Valor_Uvt", name: "Valor Sanción (UVT)" },
    { id: "Fecha_Eje_Acto_Admin", name: "Fecha Ejecutoria Acto Administrativo" },
    { id: "Decreto_1836", name: "Aplica Sanción 5 años" },
    { id: "Fecha_Inicial", name: "Fecha Inicio" },
    { id: "Fecha_Final", name: "Fecha Fin" },
    { id: "Codigo_Rnt", name: "Número de RNT" },
    { id: "Desc_Sancion_Estado", name: "Estado Sanción" },
    { id: "Usuario_Creacion", name: "Nombre Funcionario" },
  ];

  constructor(
    private formBuilder: FormBuilder,
    private reportesSancionesPersonaService: ReporteSancionesPersonasService,
    public authService: AuthService,
    private sancionesPersonasService: SancionesPersonasService,
    private readonly basicasLoVService: BasicasLoVService
  ) {}

  ngOnInit() {
    this.createPagingTable();
    this.createForm();

    const selectAllControl = new FormControl(false);
    const formControl = this.exportarList.map(() => new FormControl(false));
    this.exportarForm = this.formBuilder.group({
      exportarList: new FormArray(formControl, this.minSelectCheckbox(1)),
      selectAll: selectAllControl,
    });

    this.paginaActual = 1;
    this.titleTable();
    this.onChanges();
    this.getEstadosSanciones();
    this.onDepartamento();
  }
  getEstadosSanciones(): void{
    this.sancionesPersonasService
        .getEstadosSanciones()
        .subscribe( response =>{
          if(response.result){
            this.estados_sanciones = response.data as Array<IEstadoSancion>;
          }
        })
  }
  onDepartamento() {
    this.basicasLoVService.getDepartamentos(null).subscribe((resultadoD) => {
      if (resultadoD.result) {
        this.departamentos = resultadoD.data as Array<DepartamentoEntry>;
      }
    });
  }
  onMunicipio() {
    this.basicasLoVService
      .getMunicipiosxDepartamento(this.filtro.value.departamento_id)
      .subscribe((resultado) => {
        if (resultado.result) {
          this.municipios = resultado.data as Array<MunicipioEntry>;
        }
      });
  }
  fechaInicioChanges(){
    const control = this.filtro.get('fecha_fin');
    control.setValue(null);
  }
  createForm() {
    this.filtro = this.formBuilder.group({
      numero_resolucion       : [''],
      fecha_exp_act_admin     : [''],
      numero_rnt              : [''],
      estado_sancion_id       : [''],
      numero_identificacion   : [''],
      departamento_id         : [''],
      municipio_id            : [''],
      fecha_inicio            : [''],
      fecha_fin               : [''],
    });

    this.formCheck = this.formBuilder.group({
      orders: new FormArray([]),
    });
  }

  createPagingTable() {
    this.dataTabla = {
      paging: {} as Paging,
    } as DatoPaginadoModel;
  }

  onConsultarReportesSancionesPersonas(page: number) {
    this.reportesSancionesPersonaService
      .getDataTable({ ...this.filtro.value, numeroPagina: page })
      .subscribe((resultado) => {
        if (resultado.result) {
          this.dataTabla = resultado.data as DatoPaginadoModel;
        }
      });
  }

  onPaginado(value: number) {
    this.paginaActual = value;
    this.onConsultarReportesSancionesPersonas(value);
  }

  filtrar() {
    this.paginaActual = 1;
    this.createPagingTable();
    this.onConsultarReportesSancionesPersonas(1);
  }

  limpiar() {
    this.filtro.reset();
    this.createPagingTable();
    this.titleTable();
    this.onConsultarReportesSancionesPersonas(1);
  }

  titleTable() {
    this.headerTabla = [
      'Nombres y Apellidos',
      'Número de Identificación',
      'Departamento',
      'Municipio',
      'Dirección',
      'Número Celular',
      'Correo Electrónico',
      'Correo Electrónico Fiscal',
      'Número Resolución',
      'Fecha Expedición de Acto Administrativo',
      'Valor Sanción (UVT)',
      'Fecha Ejecutoria Acto Administrativo',
      'Aplica Sanción 5 años',
      'Fecha Inicio',
      'Fecha Fin',
      'Número de RNT',
      'Estado Sanción',
      'Nombre Funcionario'
    ];
  }

  onCheckDate(minDate: NgbDate) {
    this.fecha_inicio = {
      day: minDate.day,
      month: minDate.month,
      year: minDate.year,
    };
  }

  onChanges() {
    this.exportarForm.get("selectAll").valueChanges.subscribe((bool) => {
      this.exportarForm
        .get("exportarList")
        .patchValue(Array(this.exportarList.length).fill(bool), {
          emitEvent: false,
        });
    });

    this.exportarForm.get("exportarList").valueChanges.subscribe((val) => {
      const allSelected = val.every((bool: any) => bool);
      if (this.exportarForm.get("selecAll").value !== allSelected) {
        this.exportarForm
          .get("selectAll")
          .patchValue(allSelected, { emitEvent: false });
      }
    });
  }

  minSelectCheckbox(min = 1) {
    const validator: ValidatorFn = (formArray: FormArray) => {
      const totalSelected = formArray.controls
        .map((control) => control.value)
        .reduce((prev, next) => (next ? prev + next : prev), 0);

      return totalSelected >= min ? null : { required: true };
    };
    return validator;
  }

  submit() {
    const selectedPreferences = this.exportarForm.value.exportarList
      .map((checked: any, index: any) =>
        checked ? this.exportarList[index].id : null
      )
      .filter((value: any) => value !== null);

    this.columnasEnvio = selectedPreferences.join();

    this.reportesSancionesPersonaService
      .generarExportarSancionesPersona({
        ...this.filtro.value,
        columnas: this.columnasEnvio,
      })
      .subscribe((resultado) => {
        if (resultado.type === HttpEventType.Response) {
          if (resultado.ok) {
            this.saveAsExcelFile(
              resultado.body,
              `reporte_sanciones_personas.xlsx`
            );
          }
        }
      });
  }

  private saveAsExcelFile(data: any, fileName: string): void {
    FileSaver.saveAs(data, fileName);
  }
}
